import { render, staticRenderFns } from "./create-simple.vue?vue&type=template&id=7e306480&scoped=true"
import script from "./create-simple.vue?vue&type=script&lang=js"
export * from "./create-simple.vue?vue&type=script&lang=js"
import style0 from "./create-simple.vue?vue&type=style&index=0&id=7e306480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e306480",
  null
  
)

export default component.exports